import { useSelector } from 'react-redux';

export function useBookings() {
    return useSelector((state) => state.booking?.list);
}

export function useIsFetchingBooking() {
    return useSelector((state) => state.booking?.isFetchingBooking);
}
